import { motion } from "framer-motion";
import { RevealOnScroll } from "./Reveal";

const LINES = [
  "We believe Africa deserves access",
  "to the world's finest products",
  "without compromise.",
];

const CREED = [
  { n: "I",   text: "Trust should travel further than containers." },
  { n: "II",  text: "Quality should never depend on geography." },
  { n: "III", text: "The right partnership outlives the transaction." },
];

const CLOSING = [
  "Every partnership we build.",
  "Every shipment we coordinate.",
  "Every customer relationship we earn.",
  "Brings the world a little closer.",
];

export default function MaklanStandard() {
  return (
    <section data-testid="maklan-standard" className="section-y-lg bg-navy border-t border-white/5 overflow-hidden">
      <div className="container-editorial">
        {/* Header */}
        <div className="text-center mb-24 md:mb-32 max-w-3xl mx-auto">
          <motion.span
            initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }}
            viewport={{ once: true, amount: 0.6 }}
            transition={{ duration: 1.2, ease: [0.19, 1, 0.22, 1] }}
            className="block h-px bg-[#C5A059] w-14 mx-auto mb-8 origin-center"
          />
          <div className="overline text-[#C5A059] mb-8">The Maklan Standard</div>
          <RevealOnScroll
            element="h2"
            className="font-display text-5xl md:text-7xl leading-[0.95] tracking-tight"
            lines={["A quiet <em>standard</em>,", "held for a lifetime."]}
          />
        </div>

        {/* Two-column creed */}
        <div className="grid grid-cols-12 gap-8 md:gap-16 mb-24 md:mb-32">
          <div className="col-span-12 md:col-span-6 md:pr-8">
            {LINES.map((line, i) => (
              <motion.p
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.5 }}
                transition={{ duration: 1.3, delay: i * 0.18, ease: [0.19, 1, 0.22, 1] }}
                className="font-display text-3xl md:text-4xl italic text-white/95 leading-[1.15] mb-6"
              >
                {line}
              </motion.p>
            ))}
          </div>

          <div className="col-span-12 md:col-span-6 md:border-l md:border-white/10 md:pl-12 space-y-10 md:pt-2">
            {CREED.map((c, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, amount: 0.5 }}
                transition={{ duration: 1.2, delay: 0.4 + i * 0.14, ease: [0.19, 1, 0.22, 1] }}
                className="flex items-start gap-6"
              >
                <span className="font-display italic text-[#C5A059] text-2xl md:text-3xl leading-none pt-1 min-w-[3rem]">{c.n}</span>
                <div>
                  <p className="font-display text-xl md:text-2xl text-white/90 leading-snug">{c.text}</p>
                  <motion.span
                    initial={{ scaleX: 0 }}
                    whileInView={{ scaleX: 1 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 1.4, delay: 0.6 + i * 0.14, ease: [0.19, 1, 0.22, 1] }}
                    className="block h-px bg-white/15 w-24 mt-6 origin-left"
                  />
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Closing crescendo */}
        <div className="text-center max-w-4xl mx-auto">
          {CLOSING.map((line, i) => (
            <motion.p
              key={i}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.5 }}
              transition={{ duration: 1.3, delay: i * 0.16, ease: [0.19, 1, 0.22, 1] }}
              className={`font-display leading-tight ${
                i === CLOSING.length - 1
                  ? "text-3xl md:text-5xl text-[#C5A059] italic mt-10"
                  : "text-2xl md:text-4xl text-white/85 mb-2"
              }`}
            >
              {line}
            </motion.p>
          ))}
        </div>
      </div>
    </section>
  );
}
